module.exports = __webpack_public_path__ + "static/media/oh-actualites.29461a46.png";